import { Setting } from "./setting.model";
import { PermissionItem } from "./shared/permissionitem.model";
import { Cookie } from './cookie';

/**
 * Interface used as payload for the logon method
 */
export interface Authentication {
    name: string;
    password: string;
    culture: string;
    key: string;
}

export class User {
    private _uniqueId: string = "";
    private _id: number = 0;
    private _userName: string = "";
    private _firstName: string = "";
    private _lastName: string = "";
    private _permissions: number[] = [];
    private _settings: Setting[] = [];
    private _isrecordsmanager: boolean = false;
    private _isadministrator: boolean = false;
    private _webvieweroption: string = "";
    private _isDemo: boolean = false;
    private _showHitListIndicators: boolean = true;

    constructor(init?: Partial<User>) {
        Object.assign(this, init);
    }

    /**
     * Getters and setters
     */

    /**
     * UniqueId
     */
    public get UniqueId(): string {
        return this._uniqueId;
    }
    public set UniqueId(value: string) {
        this._uniqueId = value;
    }

    /**
     * Id
     */
    public get Id(): number {
        return this._id;
    }
    public set Id(value: number) {
        this._id = value;
    }
    public getIdFromString(strId: string | null): number {
        if (strId)
            return JSON.parse(strId);
        else
            return 0;
    }

    /**
     * Name
     */
    public get Name(): string {
        return this._userName;
    }
    public set Name(value: string) {
        this._userName = value;
    }

    public get fullName(): string {
        return this.FirstName.length > 0 && this.LastName != null && this.LastName.length > 0 ? `${this.FirstName} ${this.LastName}` : this.Name;
    }

    public get initials(): string {
        return this.FirstName.length > 0 && this.LastName != null && this.LastName.length > 0 ? `${this.FirstName.substring(0, 1)}${this.LastName.substring(0, 1)}` : this.Name.substring(0, 1).toLocaleUpperCase();
    }

    get FirstName() {
        return this._firstName;
    }

    set FirstName(value) {
        this._firstName = value;
    }

    get LastName() {
        return this._lastName;
    }

    set LastName(value) {
        this._lastName = value;
    }

    /**
     * Permissions
     */
    public get Permissions(): number[] {
        return this._permissions;
    }
    public set Permissions(value: number[]) {
        this._permissions = value;
    }
    public getPermissionsFromString(strPermission: string | null): number[] {
        if (strPermission)
            return JSON.parse(strPermission);
        else
            return [];
    }
    public getPermission(perm: PermissionItem): boolean {
        return this.Permissions.find(p => p === perm || p == PermissionItem.SystemAdministrator) != undefined;
    }

    /**
     * Settings
     */
    public get Settings(): Setting[] {
        return this._settings;
    }
    public set Settings(value: Setting[]) {
        this._settings = value;
    }
    public getSettingsFromString(strSettings: string | null): any[] {
        if (strSettings)
            return JSON.parse(strSettings);
        else
            return [];
    }

    /**
     * IsRecordsManager
     */
    public get IsRecordsManager(): boolean {
        return this._isrecordsmanager;
    }
    public set IsRecordsManager(value: boolean) {
        this._isrecordsmanager = value;
    }
    public getIsRecordsManager(strisrecordsmanager: string | null): boolean {
        if (strisrecordsmanager)
            return JSON.parse(strisrecordsmanager);
        else
            return false;
    }

    /**
     * IsAdministrator
     */
    public get IsAdministrator(): boolean {
        return this._isadministrator;
    }
    public set IsAdministrator(value: boolean) {
        this._isadministrator = value;
    }
    public getIsAdministrator(strisadministrator: string | null): boolean {
        if (strisadministrator)
            return JSON.parse(strisadministrator);
        else
            return false;
    }

    /**
     * WebViewerSelect
     */
    public get WebViewerOption() {
        return this._webvieweroption;
    }

    public set WebViewerOption(value: string) {
        this._webvieweroption = value;
    }

    public get IsViewerBrava() {
        if (this.WebViewerOption == "1") {
            return true;
        }
        return false;
    }

    public get IsViewerPDF() {
        if (this.WebViewerOption == '0') {
            return true;
        }
        return false;
    }

    /**
     * 30 sys key activation warning
     */
    public WarnSystemKeyToExpireMessage: string = "";

    /**
     * Is the server in demo mode
     */
    public get IsDemo() {
        return this._isDemo;
    }
    public set IsDemo(value: boolean) {
        this._isDemo = value;
    }
    public getBooleanFromString(strisdemo: string | null): boolean {
        if (strisdemo)
            return JSON.parse(strisdemo);
        else
            return false;
    }

    public get showHitListIndicators() {
        return this._showHitListIndicators;
    }

    public set showHitListIndicators(value: boolean) {
        this._showHitListIndicators = value;
        Cookie.write("showhitlistindicators", JSON.stringify(this._showHitListIndicators));
    }

    public get autoFitColumnsOnSearch() {
        if (Cookie.exists("autofitColumnsOnSearch") && Cookie.read("autofitColumnsOnSearch") != "") {
            return this.getBooleanFromString(Cookie.read("autofitColumnsOnSearch"));
        }

        return false;
    }

    public set autoFitColumnsOnSearch(value: boolean) {
        Cookie.write("autofitColumnsOnSearch", JSON.stringify(value), 365 * 10);
    }
}